import useQueryParams from './query-params-util';
export default function usePrebundle() {
  return useQueryParams().prebundle;
}